import React, { FC } from "react";
import styled from "styled-components";
import useContentful from "../../hooks/useContentful";
import { BlogCategory } from "./Blog";

const Link = styled.a`
  display: block;
  text-decoration: none;
  color: #1B8EFB;
  font-size: 18px;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: -0.27px;

  &:hover {
    color: #1a1b1b;
  }
`;

interface Props {
  blogUrl?: string;
  contentfulTagId?: string;
}

interface ContentfulQueryArgs {
  content_type: string;
  order: string[];
  'metadata.tags.sys.id[in]'?: string;
}

const CategoryList: FC<Props> = ({ blogUrl, contentfulTagId }) => {
  const args: ContentfulQueryArgs = {
    content_type: 'blogCategory',
    order: ['fields.title']
  };

  if (contentfulTagId) {
    args['metadata.tags.sys.id[in]'] = contentfulTagId;
  }

  const { contentfulData } = useContentful(args);

  if (!contentfulData) {
    return null;
  }

  const categories = contentfulData.items as BlogCategory[];
  return categories.map(category => (
    <Link href={`${blogUrl}?cat=${category.sys.id}`}>
      {category.fields.title}
    </Link>
  ));
}

export default CategoryList;